import { Component, Input, OnInit } from '@angular/core';
import { MessageBoxKey } from '@shared-libs/enums';
import { AppManager } from '@shared-managers/app.manager';

@Component({
	selector: 'message-box-component',
	templateUrl: 'message-box.component.html',
	styleUrls: ['./message-box.component.scss'],
})
export class MessageBoxComponent implements OnInit {
	@Input() public key: MessageBoxKey;
	public closed: boolean = false;

	constructor(private readonly appManager: AppManager) {}

	public ngOnInit(): void {
		this.loadMessageBoxState();
	}

	public close(): void {
		this.closed = true;
		this.appManager.setMessageBoxState(this.key, this.closed);
	}

	/**
	 * Load the message state
	 */
	private async loadMessageBoxState(): Promise<void> {
		this.closed = await this.appManager.getMessageBoxState(this.key);
	}
}
